import { useState, useCallback } from 'react';

export default function useToggle(initialValue = false) {
  const [value, setValue] = useState(initialValue);

  const toggle = useCallback((keyOrValue) => {
    setValue((prev) => {
      if (prev !== null && typeof prev === 'object') {
        const key = keyOrValue;
        return {
          ...prev,
          [key]: !prev[key],
        };
      }

      if (typeof keyOrValue === 'boolean') {
        return keyOrValue;
      }

      return !prev;
    });
  }, []);

  return [value, toggle, setValue];
}
